import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  makeStyles,
  Container,
  CardHeader,
  CardContent,
  Divider,
  MenuItem,
  Grid,
  InputLabel,
  TextField,
  Button,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import tokenDecoder from '../../../utils/tokenDecoder';
import { LoadingComponent } from '../../../utils/newLoader';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { DatePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import { useAlert } from "react-alert";


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  colorApprove: {
    backgroundColor: "green",
  },
}));

var screenCode = "FINANCIALYEARENDEXECUTION"

export default function FinancialYearEndExecution() {
  const classes = useStyles();
  const alert = useAlert();
  const [financialYearDetails, setFinanvialYearDetails] = useState({
    financialYearEndDate: "       - - -",
    financialYearStartDate: "       - - -",
  });
  const [executionDetails, setExecutionDetails] = useState({
    applicableYear: '',
    executedCount: '',
    modifiedDate: "       - - -"
  });
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [isViewTable, setIsViewTable] = useState(true);
  const [isBtnDisable, setIsBtnDisable] = useState(false);
  const [routeList, setRouteList] = useState({
    groupID: '0',
    factoryID: '0',
    year: ''
  })
  const navigate = useNavigate();
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  useEffect(() => {
    getPermissions();
    trackPromise(
      getGroupsForDropdown()
    );
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesByGroupID()
    )
  }, [routeList.groupID]);

  useEffect(() => {
    if (routeList.year != '') {
      trackPromise(
        getFinancialYearDetails(),
        getExecutionDetailsByFactoryAndYear(),
      );
    }
  }, [routeList.year]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFINANCIALYEARENDEXECUTION');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setRouteList({
      ...routeList,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken()),
      year: new Date()
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  async function getFactoriesByGroupID() {
    const fac = await services.getFactoriesByGroupID(routeList.groupID);
    setFactories(fac);
  }

  async function getFinancialYearDetails() {
    const financialYear = await services.getFinancialYearDetails(routeList.groupID, routeList.factoryID, moment(routeList.year).format('YYYY-MM-DD'))
    if (financialYear != null) {
      setFinanvialYearDetails({
        ...financialYearDetails,
        financialYearEndDate: moment(financialYear.financialYearEndDate).format('YYYY/MM/DD'),
        financialYearStartDate: moment(financialYear.financialYearStartDate).format('YYYY/MM/DD')
      });
      setIsBtnDisable(false);
    } else {
      setFinanvialYearDetails({
        ...financialYearDetails,
        financialYearEndDate: "       - - -",
        financialYearStartDate: "       - - -"
      });
      setIsBtnDisable(true);
    }
  }

  async function getExecutionDetailsByFactoryAndYear() {
    const res = await services.getExecutionDetailsByFactoryAndYear(routeList.groupID, routeList.factoryID, parseInt(moment(routeList.year).format('YYYY')));
    if (res.data != null) {
      setExecutionDetails({
        ...executionDetails,
        applicableYear: (res.data.applicableYear).toString(),
        executedCount: (res.data.executedCount).toString(),
        modifiedDate: res.data.modifiedDate == null ? moment(res.data.createdDate).format('YYYY/MM/DD') : moment(res.data.modifiedDate).format('YYYY/MM/DD')
      });
    } else {
      setExecutionDetails({
        ...executionDetails,
        applicableYear: moment(routeList.year).format('YYYY'),
        executedCount: "0",
        modifiedDate: "       - - -"
      });
    }
  }

  async function Start(executionDetails) {
    if (new Date() > new Date(financialYearDetails.financialYearEndDate)) {
      let model = {
        groupID: parseInt(routeList.groupID),
        factoryID: parseInt(routeList.factoryID),
        financialYearStartDate: moment(financialYearDetails.financialYearStartDate).format('YYYY-MM-DD'),
        financialYearEndDate: moment(financialYearDetails.financialYearEndDate).format('YYYY-MM-DD'),
        createdBy: tokenDecoder.getUserIDFromToken(),
        createdDate: new Date()
      }
      const execution = await services.financialYearEndExecution(model)
      if (execution.statusCode === 'Success') {
        alert.success(execution.message);
        getExecutionDetailsByFactoryAndYear();
      } else {
        alert.error(execution.message)
      }
    } else {
      alert.error(`The year of ${moment(routeList.year).format('YYYY')} is not completed`);
    }
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setRouteList({
      ...routeList,
      [e.target.name]: value
    });
  }

  function handleYearChange(e) {
    setRouteList({
      ...routeList,
      year: e
    });
  }

  function changeIconName() {
    return "Start";
  }

  function changeLableName() {
    if (new Date() > new Date(financialYearDetails.financialYearEndDate)) {
      return "Completed";
    }
    else {
      return "Not Completed";
    }
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  function decimalConvertion(rate) {
    let convertedRate = rate.toFixed(2);
    return convertedRate;
  }

  return (
    <Fragment>
      <LoadingComponent open={true} />
      <Page className={classes.root} title="Financial Year End Execution">
        <Container maxWidth={false}>
          <Box mt={0}>
            <Card>
              <CardHeader
                title={cardTitle("Financial Year End Execution")}
              />
              <PerfectScrollbar>
                <Divider />
                <CardContent style={{ marginBottom: "2rem" }}>
                  <Grid container spacing={3}>
                    <Grid item md={4} xs={12}>
                      <InputLabel shrink id="groupID">
                        Group  *
                      </InputLabel>
                      <TextField select
                        fullWidth
                        name="groupID"
                        size='small'
                        onChange={(e) => handleChange(e)}
                        value={routeList.groupID}
                        variant="outlined"
                        InputProps={{
                          readOnly: !permissionList.isGroupFilterEnabled ? true : false
                        }}
                      >
                        <MenuItem value="0">--Select Group--</MenuItem>
                        {generateDropDownMenu(groups)}
                      </TextField>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <InputLabel shrink id="factoryID">
                        Factory *
                      </InputLabel>
                      <TextField select
                        fullWidth
                        name="factoryID"
                        size='small'
                        onChange={(e) => handleChange(e)}
                        value={routeList.factoryID}
                        variant="outlined"
                        id="factoryID"
                        InputProps={{
                          readOnly: !permissionList.isFactoryFilterEnabled ? true : false
                        }}
                      >
                        <MenuItem value="0">--Select Factory--</MenuItem>
                        {generateDropDownMenu(factories)}
                      </TextField>
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePicker
                          autoOk
                          variant="inline"
                          name='year'
                          openTo="year"
                          views={["year"]}
                          label="Year"
                          helperText="Select financial year *"
                          value={routeList.year}
                          onChange={(date) => handleYearChange(date)}
                          size='small'
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                  </Grid>
                  <br /><br />
                  <Grid container spacing={3} alignItems="center" justify="center" style={{ width: '100%' }} >
                    <Box border={2} borderRadius={16} alignItems="center" justify="center" borderColor="grey" style={{ width: '50%', height: '8rem' }}>
                      <Grid item md={9} xs={12} style={{ width: '100%', marginLeft: '13%' }}>
                        <CardHeader style={{ textAlign: 'center' }} titleTypographyProps={{ variant: 'h4' }}
                          title={`About Financial Year of ${moment(routeList.year).format('YYYY')}`}
                        />
                      </Grid>
                      <Grid container spacing={3} alignItems="center" justify="center" style={{ width: '100%', marginLeft: '0.1%' }}>
                        <Grid item md={4} xs={12}>
                          <CardHeader style={{ marginTop: '-1rem', marginLeft: '10%' }} titleTypographyProps={{ variant: 'h6' }}
                            title="Start Date"
                          />
                          <TextField
                            fullWidth
                            value={financialYearDetails.financialYearStartDate}
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 20, fontStyle: "initial", textAlign: "right", marginLeft: '10%', marginTop: '-1rem' },
                              disableUnderline: true
                            }}
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <CardHeader style={{ marginTop: '-1rem', marginLeft: '10%' }} titleTypographyProps={{ variant: 'h6' }}
                            title="End Date"
                          />
                          <TextField
                            fullWidth
                            value={financialYearDetails.financialYearEndDate}
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 20, fontStyle: "initial", textAlign: "center", marginLeft: '10%', marginTop: '-1rem' },
                              disableUnderline: true
                            }}
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <CardHeader style={{ marginTop: '-1rem', marginLeft: '0%' }} titleTypographyProps={{ variant: 'h6' }}
                            title=""
                          />
                          <TextField
                            fullWidth
                            value={changeLableName()}
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 20, fontStyle: "initial", textAlign: "center", marginLeft: '13%', marginTop: '-0.5rem' },
                              disableUnderline: true
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                  <br /><br />
                  <Grid container spacing={3} alignItems="center" justify="center" style={{ width: '100%' }} >
                    <Box border={2} borderRadius={16} alignItems="center" justify="center" borderColor="green" style={{ width: '70%', height: '13rem' }}>
                      <Grid item md={9} xs={12} style={{ width: '100%', marginLeft: '13%' }}>
                        <CardHeader style={{ textAlign: 'center' }} titleTypographyProps={{ variant: 'h1' }}
                          title="Execution Status"
                        />
                      </Grid>
                      <Grid container spacing={3} alignItems="center" justify="center" style={{ width: '100%', marginLeft: '0.1%' }}>
                        <Grid item md={3} xs={12}>
                          <CardHeader style={{ marginTop: '1rem', marginLeft: '10%' }} titleTypographyProps={{ variant: 'h6' }}
                            title="Financial Year"
                          />
                          <TextField
                            fullWidth
                            value={executionDetails.applicableYear}
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 30, fontStyle: "initial", textAlign: "right", marginLeft: '20%' },
                              disableUnderline: true
                            }}
                          />
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <CardHeader style={{ marginTop: '1rem', marginLeft: '0%' }} titleTypographyProps={{ variant: 'h6' }}
                            title="Executded Count"
                          />
                          <TextField
                            fullWidth
                            value={executionDetails.executedCount}
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 30, fontStyle: "initial", textAlign: "center", marginLeft: '30%' },
                              disableUnderline: true
                            }}
                          />
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <CardHeader style={{ marginTop: '1rem', marginLeft: '0%' }} titleTypographyProps={{ variant: 'h6' }}
                            title="Last Executed Date"
                          />
                          <TextField
                            fullWidth
                            value={executionDetails.modifiedDate}
                            InputProps={{
                              readOnly: true,
                              style: { fontSize: 20, fontStyle: "initial", textAlign: "center", marginLeft: '13%', marginTop: '0.7rem' },
                              disableUnderline: true
                            }}
                          />
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <CardHeader style={{ marginLeft: '0rem', marginTop: '1rem' }} titleTypographyProps={{ variant: 'h6' }}
                            title=""
                          />
                          <Button
                            color="primary"
                            disabled={isBtnDisable}
                            type="submit"
                            variant="contained"
                            size="large"
                            fullWidth="true"
                            className={classes.colorApprove}
                            onClick={() => trackPromise(Start(routeList))}
                            style={{ marginLeft: '0rem' }}
                          >
                            {changeIconName()}
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </CardContent>
              </PerfectScrollbar>
            </Card>
          </Box>
        </Container>
      </Page>
    </Fragment>
  );
};

